import React, { useContext } from 'react';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { Row, Button, MasterDetailForm, Widget } from '@digital/ui';
import { Modal } from 'antd';
import { EnviarDemanda, enviarModificacaoDemanda, desistirModificacaoDemanda } from '@app/api/demanda';

function ModalFinalizarEtapaRequisicao() {
  const {
    demandaData,
    exibirModalFinalizarEtapaRequisicao,
    setExibirModalFinalizarEtapaRequisicao,
    eliminacaoVisitaTecnica,
    eliminacaoDirecionamentoFornecedor,
    eliminacaoEmergencial,
    justificativaDirecionamento,
    caracteristicaEmergencia,
    justificativaEmergencia,
    update,
    setUpdate,
  } = useContext(QuestionarioContextProvider);

  const [exibirModalDesistirContinuar, setExibirModalDesistirContinuar] = React.useState(false);

  const onDiscordar = () => {
    setExibirModalFinalizarEtapaRequisicao(false);
  };
  const onConcordar = () => {
    if (demandaData) {
      if (demandaData.isModificando == false || !demandaData.isModificando) {
        EnviarDemanda({
          ...demandaData,
          eliminacaoVisitaTecnica,
          eliminacaoDirecionamentoFornecedor,
          eliminacaoEmergencial,
          justificativaDirecionamento,
          justificativaEmergencia,
          caracteristicaEmergencia,
        }).then(data => {
          setUpdate(!update);
        });
      } else {
        enviarModificacaoDemanda(demandaData.id).then(data => {
          if (data && data.invalid && data.aprovada === false) {
            setExibirModalDesistirContinuar(true);
          }
          setUpdate(!update);
        });
      }
    }

    setExibirModalFinalizarEtapaRequisicao(false);
  };

  const onDesistir = () => {
    if (demandaData) {
      desistirModificacaoDemanda(demandaData.id).then(data => {
        setUpdate(!update);
      });
    }
  };

  return (
    <>
      <Modal
        title="Confirmar"
        width="680px"
        visible={exibirModalFinalizarEtapaRequisicao}
        onCancel={() => {
          setExibirModalFinalizarEtapaRequisicao(false);
        }}
        footer={null}>
        <MasterDetailForm
          actions={[
            <Button
              id='mrn-button-modal-ModalFinalizarEtapaRequisicao-nao'
              key="discordarBtn" type="link" onClick={onDiscordar}>
              Não
            </Button>,
            <Button
              id='mrn-button-modal-ModalFinalizarEtapaRequisicao-sim'
              key="concordarBtn" type="primary" onClick={onConcordar}>
              Sim
            </Button>,
          ]}>
          <Widget>
            <Row>
              <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                Deseja concluir {demandaData && demandaData.isModificando ? 'as modificações na ' : 'e emitir a '}
                Requisição?
              </p>
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>

      <Modal
        title="Desistir ou continuar modificação"
        width="680px"
        visible={exibirModalDesistirContinuar}
        onCancel={() => {
          setExibirModalDesistirContinuar(false);
        }}
        footer={null}>
        <MasterDetailForm
          actions={[
            <Button
              id='mrn-button-modal-ModalDesistirContinuar-nao'
              key="discordarBtn" type="link" onClick={onDesistir}>
              Desistir
            </Button>,
            <Button
              id='mrn-button-modal-ModalDesistirContinuar-sim'
              key="concordarBtn" type="primary" onClick={() => setExibirModalDesistirContinuar(false)}>
              Continuar
            </Button>,
          ]}>
          <Widget>
            <Row>
              <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                Deseja continuar modificando a Requisição?
              </p>
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
}

export default ModalFinalizarEtapaRequisicao;
